/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useRef, useCallback } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import {
  MdSearch,
  MdCheckCircle,
  MdCancel,
  MdVisibility,
  MdUpload,
} from "react-icons/md";
import HomeService from "../../../services/home.service";
import PackageService from "../../../services/package.service";
import { Constants } from "../../../utils";
import ConfirmModal from "../../../components/confirm-modal";

const ViewPhotos = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const item = state?.item || {};

  const [search, setSearch] = useState("");
  const [data, setData] = useState([]);
  const [arePhotosPublished, setArePhotosPublished] = useState(
    item?.published_photos || false,
  );
  const [loading, setLoading] = useState(true);

  // Estados para Modales de Confirmación
  const [isPublishModalOpen, setIsPublishModalOpen] = useState(false);
  const [loadingPublish, setLoadingPublish] = useState(false);

  const [isUnpublishModalOpen, setIsUnpublishModalOpen] = useState(false);
  const [loadingUnpublish, setLoadingUnpublish] = useState(false);

  const timerRef = useRef(null);

  const load = useCallback(
    async (currentSearch = search) => {
      try {
        const res = await HomeService.admin.viewContent({
          package_id: item?.id,
          search: currentSearch,
          grouped_by_user: true,
        });
        setData(res.data || []);
      } catch (error) {
        toast.error(
          typeof error === "string"
            ? error
            : error?.response?.data?.message ||
                error?.message ||
                "Error al cargar el contenido",
        );
      } finally {
        setLoading(false);
      }
    },
    [item?.id, search],
  );

  useEffect(() => {
    load();
  }, [load]);

  const handleSearch = (e) => {
    const val = e.target.value;
    setSearch(val);
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      load(val);
    }, 1000);
  };

  const handleConfirmPublish = async () => {
    setLoadingPublish(true);
    try {
      const res = await PackageService.admin.changePhotosStatus({
        package_id: item.id,
        status: Constants.PHOTOS_STATUS.PUBLISHED,
      });
      if (res.result) {
        toast.success("Se ha publicado las fotos correctamente");
        setArePhotosPublished(true);
        setIsPublishModalOpen(false);
      }
    } catch (error) {
      const errorMsg =
        typeof error === "string"
          ? error
          : error?.response?.data?.message ||
            error?.message ||
            "Error al publicar fotos";
      toast.error(errorMsg);
    } finally {
      setLoadingPublish(false);
    }
  };

  const handleConfirmUnpublish = async () => {
    setLoadingUnpublish(true);
    try {
      const res = await PackageService.admin.changePhotosStatus({
        package_id: item.id,
        status: Constants.PHOTOS_STATUS.UNPUBLISHED,
      });
      if (res.result) {
        toast.success("Se ha despublicado las fotos");
        setArePhotosPublished(false);
        setIsUnpublishModalOpen(false);
      }
    } catch (error) {
      const errorMsg =
        typeof error === "string"
          ? error
          : error?.response?.data?.message ||
            error?.message ||
            "Error al despublicar fotos";
      toast.error(errorMsg);
    } finally {
      setLoadingUnpublish(false);
    }
  };

  const selectFile = (productItem) => {
    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = "image/*";
    fileInput.onchange = async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      toast.loading("Subiendo foto...", { id: "uploading" });
      try {
        const res = await PackageService.admin.uploadPhotos({
          package_product_id: productItem.id,
          file,
          hasFile: true,
        });

        if (res.result) {
          toast.success("Se ha subido la foto correctamente", {
            id: "uploading",
          });
          load();
        } else {
          toast.dismiss("uploading");
          toast.error("No se pudo subir la foto");
        }
      } catch (error) {
        toast.dismiss("uploading");
        const errorMsg =
          typeof error === "string"
            ? error
            : error?.response?.data?.message ||
              error?.message ||
              "Error al subir la foto";
        toast.error(errorMsg);
      }
    };
    fileInput.click();
  };

  return (
    <div className="max-w-6xl mx-auto py-6 px-4 md:px-8">
      {/* HEADER / INFO BL */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 mb-6">
        <button
          onClick={() => navigate(-1)}
          className="text-sm font-bold text-[#1D3B8B] hover:underline mb-4 inline-block"
        >
          ← Volver
        </button>
        <h1 className="text-xl font-bold text-gray-900 uppercase mb-1">
          Contenido de: {item.number}
        </h1>
        <p className="text-sm font-semibold text-purple-600 uppercase mb-6">
          {item.code || item.internal_code || ""}
        </p>

        <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4 border-t border-gray-100 pt-6">
          <div className="w-full md:w-1/3">
            <label className="block text-xs font-bold text-gray-600 uppercase mb-2">
              Cod. Cliente o RIF
            </label>
            <div className="relative">
              <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                <MdSearch size={20} className="text-gray-400" />
              </div>
              <input
                type="text"
                placeholder="Buscar por cliente"
                value={search}
                onChange={handleSearch}
                className="w-full pl-10 pr-4 py-2.5 border border-gray-200 rounded-xl bg-white shadow-sm focus:ring-2 focus:ring-[#1D3B8B] focus:border-transparent outline-none transition-all text-sm"
              />
            </div>
          </div>

          <div className="flex flex-col md:flex-row items-start md:items-center gap-4 w-full md:w-auto">
            <span
              className={`text-sm font-bold ${
                arePhotosPublished ? "text-green-600" : "text-red-500"
              }`}
            >
              {arePhotosPublished ? "FOTOS PUBLICADAS" : "FOTOS NO PUBLICADAS"}
            </span>

            {arePhotosPublished ? (
              <button
                type="button"
                onClick={() => setIsUnpublishModalOpen(true)}
                className="bg-purple-600 text-white px-5 py-2.5 rounded-xl font-bold text-sm shadow-md hover:bg-purple-700 transition-colors w-full md:w-auto"
              >
                Despublicar Fotos
              </button>
            ) : (
              <button
                type="button"
                onClick={() => setIsPublishModalOpen(true)}
                className="bg-purple-600 text-white px-5 py-2.5 rounded-xl font-bold text-sm shadow-md hover:bg-purple-700 transition-colors w-full md:w-auto"
              >
                Publicar Fotos
              </button>
            )}
          </div>
        </div>
      </div>

      {/* TABLA DE CONTENIDO */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 overflow-hidden">
        <div className="overflow-x-auto">
          <table className="w-full text-sm text-left text-gray-600">
            <thead className="text-xs text-gray-500 uppercase bg-gray-50/80 border-b border-gray-100">
              <tr>
                <th className="px-6 py-4 font-semibold">Cliente</th>
                <th className="px-6 py-4 font-semibold text-center">Fotos</th>
                <th className="px-6 py-4 font-semibold text-center">Acción</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {loading && data.length === 0 && (
                <tr>
                  <td
                    colSpan="3"
                    className="px-6 py-8 text-center text-[#1D3B8B] font-medium"
                  >
                    Cargando...
                  </td>
                </tr>
              )}

              {!loading && data.length === 0 && (
                <tr>
                  <td
                    colSpan="3"
                    className="px-6 py-8 text-center text-gray-400"
                  >
                    No se han encontrado registros
                  </td>
                </tr>
              )}

              {data.map((i, index) => {
                const hasPhotos = i.photos && i.photos.length > 0;
                return (
                  <tr
                    key={index}
                    className="hover:bg-gray-50/50 transition-colors"
                  >
                    <td className="px-6 py-4 font-bold text-gray-800">
                      {i?.user?.code || "-"}
                    </td>
                    <td className="px-6 py-4">
                      <div className="flex items-center justify-center gap-2">
                        {hasPhotos ? (
                          <MdCheckCircle className="text-green-500" size={20} />
                        ) : (
                          <MdCancel className="text-red-400" size={20} />
                        )}
                        {hasPhotos && (
                          <button
                            type="button"
                            onClick={() =>
                              navigate("/admin/packages/photos/details", {
                                state: { item: i },
                              })
                            }
                            className="flex items-center gap-1 text-[#1D3B8B] font-medium underline hover:text-[#152a66] transition-colors ml-2"
                          >
                            <MdVisibility size={16} />
                            <span>Ver</span>
                          </button>
                        )}
                      </div>
                    </td>
                    <td className="px-6 py-4 text-center">
                      <button
                        type="button"
                        onClick={() => selectFile(i)}
                        className="inline-flex items-center gap-1.5 text-blue-600 font-medium underline hover:text-blue-800 transition-colors"
                      >
                        <MdUpload size={16} />
                        <span>Cargar fotos</span>
                      </button>
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>

      <ConfirmModal
        isOpen={isPublishModalOpen}
        title="¿Desea publicar las fotos?"
        message="Las fotos estarán visibles para los clientes."
        confirmText="Publicar"
        variant="primary"
        loading={loadingPublish}
        onConfirm={handleConfirmPublish}
        onClose={() => setIsPublishModalOpen(false)}
      />

      <ConfirmModal
        isOpen={isUnpublishModalOpen}
        title="¿Desea despublicar las fotos?"
        message="Las fotos dejarán de estar visibles para los clientes."
        confirmText="Despublicar"
        variant="danger"
        loading={loadingUnpublish}
        onConfirm={handleConfirmUnpublish}
        onClose={() => setIsUnpublishModalOpen(false)}
      />
    </div>
  );
};

export default ViewPhotos;
